// Common country dial codes for parent mobile
export const COUNTRY_CODES = [
  { code: "+91", country: "India" },
  { code: "+971", country: "UAE" },
  { code: "+1", country: "USA / Canada" },
  { code: "+44", country: "UK" },
  { code: "+65", country: "Singapore" },
  { code: "+61", country: "Australia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+81", country: "Japan" },
  { code: "+86", country: "China" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+974", country: "Qatar" },
  { code: "+968", country: "Oman" },
  { code: "+60", country: "Malaysia" },
  { code: "+64", country: "New Zealand" },
  { code: "+27", country: "South Africa" },
  { code: "+34", country: "Spain" },
  { code: "+39", country: "Italy" },
  { code: "+41", country: "Switzerland" },
  { code: "+31", country: "Netherlands" },
  { code: "+45", country: "Denmark" },
  { code: "+46", country: "Sweden" },
  { code: "+47", country: "Norway" },
  { code: "+92", country: "Pakistan" },
  { code: "+880", country: "Bangladesh" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+977", country: "Nepal" },
];

export const ACADEMIC_YEARS = ["2026 - 2027", "2027 - 2028"];

export const SOURCES = [
  "Walk-in enquiry",
  "Telephonic enquiry",
  "Google search",
  "Referred by relatives or friends",
  "Social media",
  "Advertisement",
  "School event / open house",
  "Other",
];

export const PREFERRED_STARTS = [
  "August (start of academic year)",
  "Mid-term entry",
  "As soon as possible",
];

export const GENDERS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];
